// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dispo .v-select__selections{height:29px!important;overflow-y:auto}", ""]);
// Exports
module.exports = exports;
